import React, {Component} from "react";
import {Logo,Aside} from 'react-template'
import NavBar from "./Navbar";

export default class Navegacao extends Component {

    componentDidMount() {
    }

    render() {
        return (
            <Aside displayNav={this.props.displayNav}>
                    <Logo titulo={process.env.REACT_APP_NAME} ariahidden="true" />
                    <NavBar/>
            </Aside>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/navegacao/Navegacao.js